import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectShipmentDetailOpen = state => {
    return selectOwnState(state).shipmentDetailOpen
}



// WEBPACK FOOTER //
// ./src/modules/logistic/state/list/selector.js